import { Routes } from '@angular/router';
import { PaginaErroreComponent } from './private/pagina-errore/pagina-errore.component';
import { LandingImatraComponent } from './private/landing/landing-imatra/landing-imatra.component';
import { LandingAicComponent } from './private/landing/landing-aic/landing-aic.component';
import { RecessoComponent } from './private/recesso/recesso.component';

export const routes: Routes = [
	{ path: 'landing-page-imatra', component: LandingImatraComponent },
	{ path: 'landing-page-aic', component: LandingAicComponent },
	{ path: 'recesso', component: RecessoComponent },
	{
		path: '',
		loadChildren: () => import('./private/private.routes').then((r) => r.routes),
	},
	{
		path: '404',
		component: PaginaErroreComponent,
	},
	{ path: '**', redirectTo: '404' },
];
